export default "__VITE_ASSET__DnfrP7y5__"